import { Link } from 'react-router-dom';
import { salon } from '../../data/content';
import { legalDocs } from '../../data/legal';

/** Eén regel onder Mijn omgeving: salon, juridisch en contact. De grote footer hoort bij de winkel. */
export function AccountFooter() {
  return <footer className="border-t border-line bg-shell" data-id="element-7687" data-mp="2frd5lnlnkt08">
      <div className="mx-auto flex max-w-content flex-col gap-3 px-5 py-6 text-[13px] text-muted sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-10" data-id="element-7688" data-mp="2kon1nm3js2x1">
        <p data-id="element-7689" data-mp="2tp1q2ubt5y4r">
          © {new Date().getFullYear()} {salon.name} · KvK {salon.kvk}
        </p>
        <nav aria-label="Juridisch en contact" data-id="element-7690" data-mp="2tmp3g3v3uzld">
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-7691" data-mp="2ygtbkqg3xdo1">
            {legalDocs.map(d => <li key={d.path} data-id="element-7692" data-mp="33dtewtlko2bg">
                <Link to={d.path} className="transition-colors duration-150 ease-soft hover:text-ink" data-id="element-7693" data-mp="33gz408u7b476">
                  {d.title}
                </Link>
              </li>)}
            <li data-id="element-7694" data-mp="3ddkdb6d971gt">
              <Link to="/contact" className="transition-colors duration-150 ease-soft hover:text-ink" data-id="element-7695" data-mp="3day5d5mgajy2">
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>;
}